import React, { Component } from "react";
import "../ClientTable.css";

class PromoCodeTable extends Component {
  state = {
    searchTerm: "",
    sortField: null,
    sortDirection: "asc",
    currentPage: 1,
    itemsPerPage: 10,
  };

  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value, currentPage: 1 });
  };

  handleSort = (field) => {
    const { sortField, sortDirection } = this.state;

    if (sortField === field) {
      this.setState({
        sortDirection: sortDirection === "asc" ? "desc" : "asc",
      });
    } else {
      this.setState({
        sortField: field,
        sortDirection: "asc",
      });
    }
  };

  getFilteredData = () => {
    const { data } = this.props;
    const { searchTerm, sortField, sortDirection } = this.state;

    let filtered = [...data];

    if (searchTerm) {
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    if (sortField) {
      filtered.sort((a, b) => {
        const aVal = a[sortField] ?? "";
        const bVal = b[sortField] ?? "";

        if (sortDirection === "asc") return aVal > bVal ? 1 : -1;
        return aVal < bVal ? 1 : -1;
      });
    }

    return filtered;
  };

  getPaginatedData = () => {
    const { currentPage, itemsPerPage } = this.state;
    const filtered = this.getFilteredData();
    return filtered.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  };

  formatValue = (value, field, row) => {
    if (value === null || value === undefined || value === "") return "-";

    if (field === "discount_display") {
      return <strong>{value}</strong>;
    }

    if (field === "is_active") {
      return value ? (
        <span className="badge badge-success">Активен</span>
      ) : (
        <span className="badge badge-secondary">Выключен</span>
      );
    }

    if (field === "is_register_promo_code") {
      return value ? (
        <span className="badge badge-success">Да</span>
      ) : (
        <span className="badge badge-secondary">Нет</span>
      );
    }

    if (field === "is_valid_status") {
      return value.valid ? (
        <span className="badge badge-success">{value.message}</span>
      ) : (
        <span className="badge badge-danger">{value.message}</span>
      );
    }

    if (field === "valid_from" || field === "valid_until") {
      return new Date(value).toLocaleString("ru-RU");
    }

    return value;
  };

  render() {
    const { columns, title, onEdit, onDelete } = this.props;
    const { searchTerm, sortField, sortDirection, currentPage } = this.state;

    const data = this.getPaginatedData();
    const totalPages = Math.ceil(
      this.getFilteredData().length / this.state.itemsPerPage
    );

    return (
      <div className="client-table-container">
        <div className="table-header">
          <h3>{title || "Промокоды"}</h3>
          <input
            className="form-control search-input"
            placeholder="Поиск..."
            value={searchTerm}
            onChange={this.handleSearch}
          />
        </div>

        <div className="table-responsive">
          <table className="table table-hover table-bordered">
            <thead className="thead-light">
              <tr>
                {columns.map((col) => (
                  <th
                    key={col.field}
                    onClick={() => this.handleSort(col.field)}
                    className="sortable-header"
                  >
                    {col.header}
                    {sortField === col.field && (
                      <span>{sortDirection === "asc" ? " ▲" : " ▼"}</span>
                    )}
                  </th>
                ))}
                {(onEdit || onDelete) && <th>Действия</th>}
              </tr>
            </thead>
            <tbody>
              {data.length ? (
                data.map((row) => (
                  <tr key={row.id}>
                    {columns.map((col) => (
                      <td key={col.field}>
                        {this.formatValue(row[col.field], col.field, row)}
                      </td>
                    ))}
                    {(onEdit || onDelete) && (
                      <td>
                        {onEdit && (
                          <button
                            className="btn btn-sm btn-primary mr-2"
                            onClick={() => onEdit(row)}
                          >
                            ✏️
                          </button>
                        )}
                        {onDelete && (
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => onDelete(row)}
                          >
                            🗑
                          </button>
                        )}
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length + 1} className="text-center">
                    Нет данных
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="pagination-container">
            <ul className="pagination">
              {[...Array(totalPages)].map((_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      this.setState({ currentPage: i + 1 })
                    }
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default PromoCodeTable;
